import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  TAGS_INDEX_REQUESTED,
  TAGS_INDEX_SUCCESS,
  TAGS_INDEX_FAILURE,
} from '../types';

export const tagsIndexRequested = () => {
  return {
    type: TAGS_INDEX_REQUESTED
  }
};

export const tagsIndexSuccess = (tags) => {
  return {
    type: TAGS_INDEX_SUCCESS,
    payload: tags
  }
};

export const tagsIndexFailure = () => {
  return {
    type: TAGS_INDEX_FAILURE
  }
};

export const tagsIndex = () => {
  return async (dispatch) => {
    dispatch(tagsIndexRequested());

    const endPoint = Config.baseUrl + Config.tags;

    return Axios.get(endPoint, { headers: await authHeaders() })
      .then((response) => {
        dispatch(tagsIndexSuccess(response.data));
      })
      .catch(() => {
        dispatch(tagsIndexFailure());
      });
  }
}
